import { render, staticRenderFns } from "./choose_payment.vue?vue&type=template&id=1bbd6344&scoped=true&"
import script from "./choose_payment.vue?vue&type=script&lang=js&"
export * from "./choose_payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd6344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbd6344')) {
      api.createRecord('1bbd6344', component.options)
    } else {
      api.reload('1bbd6344', component.options)
    }
    module.hot.accept("./choose_payment.vue?vue&type=template&id=1bbd6344&scoped=true&", function () {
      api.rerender('1bbd6344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/sys/notification/choose_payment.vue"
export default component.exports